// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"d4563d1e","137":"7b52d347","191":"37f40dea","336":"380acd24","369":"059d0342"}[chunkId] + ".chunk.js";
};